import * as React from "react";
const SvgManualPick20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17 10.853V17h2V1H1v16h2v-6.147h14ZM3 3h14v2h-2V3.667h-3.954V5H3V3Zm0 3.5v2.853h.968V7.32h5v2.033H17V6.5H3Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M9.016 11.566v4.595l-1.9-1.867-1.414 1.414 3.607 3.574.707.708 4.282-4.282-1.415-1.414-1.867 1.867v-4.595h-2Z"
    })
  );
export default SvgManualPick20Px;
